
<ngx-spinner type="square-jelly-box"><h3>Loading...</h3></ngx-spinner>
@if ({propInfo: propInfo$ | async, error: propErrors$ | async}; as data) {
  <div style="height: auto;"  >
    <div [hidden]="data.error ? true : false" >
      @if (data.propInfo) {
        <div style="width: 100vw; height: 100vh;">
          <div style="
                      /* vertical center */
                      margin: 0;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      /* vertical center */

                      width: auto;
                      min-width: 380px !important;
                      max-width: 490px !important;
                      height: auto;
                      font-size: large;
                      text-align: center;" >

            @if (unsubscribeSuccess) {
              <!-- Success Page -->
              <div class="success-container">
                <div class="success-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <h2 class="success-title">You have been unsubscribed!</h2>
                <p class="success-message">Thank you for submission.</p>
              </div>
            } @else {
              <!-- Unsubscribe Form -->
              <div class="unsubscribe-container">
                <h4 style="text-align: left;">Unsubscribe From Upgrade Offers</h4>
                <div style="margin-left: 5px;">
                  <div class="div-unsubscribe">
                    <label>
                      <input class="checkbox-unsubscribe" type="checkbox" [(ngModel)]="allUpgrades" name="allUpgrades" />
                      &nbsp;
                      All properties using this service
                    </label>
                  </div>
                  <div class="div-unsubscribe">
                    <label>
                      <input class="checkbox-unsubscribe" type="checkbox" [(ngModel)]="propertyUpgrades" name="propertyUpgrades" />
                      &nbsp;
                      {{data.propInfo.prop_name_public | titlecase}}
                    </label>
                  </div>
                  <div class="div-unsubscribe">
                    <button
                      class="button-request" #buttonUnsubscribeProperty
                      style="margin-left: 0px;"
                      (click)="this.unsubscribeAllOffers()">Unsubscribe
                    </button>
                  </div>
                </div>
                @if (errorUnsubscribe) {
                  <div class="error-message">{{this.message}}</div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
